import {HttpRequest} from '../Data/HttpRequest'
import {server} from '../Data/BuildEnvironment'
import {OrderExportOptions} from '../Data/OrderExportOptions'
import {OrderExportSelection} from '../Data/OrderExportSelection'
import {SerializedOrderFilter} from '../Data/SerializedOrderFilters'

export function listForCis2User(
    manufacturerId: number,
    cis2UserId: number,
): HttpRequest {
    return {
        verb: 'GET',
        url: `${server}/manufacturers/${manufacturerId}/cis-users/${cis2UserId}/order-exports`,
        headers: {Accept: 'application/json'},
    }
}

export function create(
    manufacturerId: number,
    filters: SerializedOrderFilter[],
    options: OrderExportOptions,
    selection: OrderExportSelection
): HttpRequest {
    return {
        verb: 'POST',
        url: `${server}/manufacturers/${manufacturerId}/order-exports`,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({filters, options, ...selection}),
    }
}

export function download(id: number): HttpRequest {
    return {
        verb: 'GET',
        url: `${server}/order-exports/${id}/download`,
        headers: {Accept: 'application/zip'},
    }
}

export function retrieve(id: number): HttpRequest {
    return {
        verb: 'GET',
        url: `${server}/order-exports/${id}`,
        headers: {Accept: 'application/json'}
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/OrderExportResource.ts